export default "__VITE_ASSET__2kvqPqm4__"